import {
  experienceVideoEmbed,
  safeExperienceDestination,
} from '@/lib/member-experience';

export function ExperienceVideo({
  url,
  title,
}: {
  url: string;
  title: string;
}) {
  const embed = experienceVideoEmbed(url);
  if (embed)
    return (
      <iframe
        src={embed}
        title={title}
        className="aspect-video w-full rounded-lg border-0"
        allow="fullscreen; picture-in-picture"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    );
  const destination = safeExperienceDestination(url);
  return destination ? (
    <a
      href={destination}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary inline-block font-medium underline"
    >
      Abrir vídeo em uma nova aba
    </a>
  ) : (
    <p role="alert">O vídeo não está disponível.</p>
  );
}
